// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__g87xX","button":"button__WTDKl","icon":"icon__VDkec"};